<template>
    <div>
        <headline-banner/>
        <service-team-membership/>
    </div>
</template>

<script>
    import HeadlineBanner from './HeadlineBanner'
    import ServiceTeamMembership from './ServiceTeamMembership'

    export default {
        name: 'Home',
        components: {ServiceTeamMembership, HeadlineBanner}
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Home.vue